import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReimbursementService } from '../reimbursement.service';
import { Departments, RimResponse, userDetails, ListDepartments } from '../reimbursement.interfaces';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable } from "rxjs";
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { FlashService } from '../../flash/flash.service';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-reimbursement-user-edit',
  templateUrl: './reimbursement-user-edit.component.html',
  styleUrls: ['./reimbursement-user-edit.component.css']
})
export class ReimbursementUserEditComponent implements OnInit {
  user;
  sub
  id;
  total;
  submit = false;
  status: ListDepartments[];
  statusKey;
  updateData: RimResponse;
  expensesItems: userDetails;
  editForm: FormGroup;
  departments: Observable<Departments>;
  categories: Observable<Departments>;
  myOptions: INgxMyDpOptions = {
    dateFormat: 'yyyy-mm-dd'
  };
  k;
  attachments;
  i;
  fileError: boolean;
  sum;
  currentDate;
  dateError: boolean;
  itemsdateError: boolean;
  currentDateError: boolean;
  @ViewChild('closeModal') close: ElementRef;
  @ViewChild('selectedName') selectedName: any;

  invalidError = false;
  isSelected: boolean;
  paymentTypes = [
    {
      'key': 'Cash',
      'value': 'Cash'
    },
    {
      'key': 'Google Pay',
      'value': 'Google Pay',
    }, {
      'key': ' Phone Pe',
      'value': 'Phone Pe',
    },
    {
      'key': 'NEFT/IMPS',
      'value': 'NEFT',
    }
  ]
  constructor(
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location, private router: Router,
    private flashService: FlashService, private formBuilder: FormBuilder, private reimbur: ReimbursementService) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.departments = this.reimbur.getDepartments();
    this.categories = this.reimbur.getCategories();
    this.getStatus();
  }

  getStatus() {
    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "submitted") {
          this.statusKey = (status.key);
        }
      });
    });
  }
  selectInput(event) {
    let selected = event.target.value;
    if (selected == "Cash") {
      this.isSelected = true;
      this.editForm.controls.payment_details.clearValidators();
      this.editForm.controls.payment_details.updateValueAndValidity();

    } else {
      this.isSelected = false;
      this.editForm.controls.payment_details.setValidators(Validators.required);
      this.editForm.controls.payment_details.updateValueAndValidity();
    }
  }

  ngOnInit() {
    this.sum = 0;
    this.sub = this.route.params.subscribe(async (params) => {
      this.id = params['id'];
      this.spinnerService.show();
      this.expensesItems = await this.reimbur.getUserExpensesItems(this.id);

      this.spinnerService.hide();
      const fromDate = new Date(this.expensesItems.from_date);
      const toDate = new Date(this.expensesItems.to_date);
      this.editForm = this.formBuilder.group({
        id: this.user.id,
        purpose: [this.expensesItems.purpose, Validators.required],
        from_date: this.stringToDate(fromDate),
        to_date: this.stringToDate(toDate),
        status_id: this.expensesItems.status_id,
        payment_type: [this.expensesItems.payment_type, Validators.required],
        payment_details: [this.expensesItems.payment_details],
        items: this.itemsArray(this.expensesItems)
      }, { validator: this.checkDates('from_date', 'to_date') });
    });
  }

  public checkDates(startKey: string,
    endKey: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const startDate = group.controls[startKey];
      const endDate = group.controls[endKey];
      if (startDate.value !== '' && endDate.value !== '') {
        startDate.setErrors(null);
        endDate.setErrors(null);
        const d_startDate = new Date(startDate.value.formatted);
        const d_endDate = new Date(endDate.value.formatted);

        const d_currentDate = new Date();
        let startValid = true;
        let endValid = true;
        if (startDate.value !== '') {
          if (d_startDate > d_currentDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than Current Date.' });
            startValid = false;
          }
        }
        if (endDate.value !== '') {
          if (d_endDate > d_currentDate) {
            endDate.setErrors({ 'type': 'endtDateLess', 'message': 'End Date should be less than Current Date.' });
            endValid = false;
          }
        }
        if (startDate.value !== '' && endDate.value !== '' && startValid && endValid) {
          if (d_startDate > d_endDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than End Date.' });
            endDate.setErrors({ 'type': 'startDateLess', 'message': 'End Date should be greater than Start Date.' });
          }
        }
      }
      return;
    };
  }

  checkDatesItems(date: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const itemDate = group.controls[date];
      if (itemDate.value !== '') {
        itemDate.setErrors(null);
        const d_ItemDate = new Date(itemDate.value.formatted);
        const currentDate = new Date();
        let itemDateValid = true;
        let fromdateValid = true;
        let todateValid = true;
        if (itemDate.value !== '') {
          if (d_ItemDate > currentDate) {
            itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be less than Current Date.' });
            itemDateValid = false;
          }
        }
        if (this.editForm) {
          const d_startDate = new Date(this.editForm.controls['from_date'].value.formatted);
          const d_endDate = new Date(this.editForm.controls['to_date'].value.formatted);
          if (itemDate.value !== '' && this.editForm.controls['from_date'].value !== '' && this.editForm.controls['to_date'].value !== '') {
            if (d_ItemDate < d_startDate) {
              itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
              fromdateValid = false;
            }
            else if (d_ItemDate < new Date(this.expensesItems.from_date)) {
              itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
              fromdateValid = false;
            }
            if (d_ItemDate > d_endDate) {
              itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
              todateValid = false;
            }
            else if (d_ItemDate > new Date(this.expensesItems.to_date)) {
              itemDate.setErrors({ 'type': 'startDateLess', 'message': 'Item Date should be give inbetween from_Date to_date.' });
              todateValid = false;
            }
          }
        }
      }
      return;
    }
  }

  itemsArray(data) {
    let itemControl = new FormArray([]);
    if (data && data.items) {
      data.items.forEach(itemData => {
        this.sum += itemData.cost;
        const date = new Date(itemData.date);
        itemControl.push(this.formBuilder.group({
          id: itemData.id,
          date: this.stringToDate(date),
          description: [itemData.description, Validators.required],
          category: [itemData.category_id, Validators.required],
          cost: [itemData.cost, Validators.required],
          attachments: this.attachmentArray(itemData.attachments)
        }, { validator: this.checkDatesItems('date') }))
      })
    } else {
      return this.formBuilder.group({
        'date': ['', Validators.required],
        'description': ['', Validators.required],
        'category': ['', Validators.required],
        'cost': ['', Validators.required],
        'attachments': this.formBuilder.array([], Validators.required)
      }, { validator: this.checkDatesItems('date') })
    }
    return itemControl;
  }


  attachmentNewArray() {
    let attachmentsControl = new FormArray([], Validators.required);
    attachmentsControl.push(this.formBuilder.group({
      key: ['', Validators.required],
      name: ['', Validators.required],
      url: ['', Validators.required]
    }));
    return attachmentsControl;
  }

  totalCost() {
    let sum = 0;
    this.total = this.editForm.value.items;
    for (let j = 0; j < this.total.length; j++) {
      sum += Number(this.total[j].cost);
    }
    this.sum = sum;
  }

  locationBack() {
    this.location.back();
  }

  attachmentArray(attachments) {
    let attachmentsControl = new FormArray([], Validators.required);
    attachments.forEach(file => {
      attachmentsControl.push(this.formBuilder.group({
        key: file.key,
        name: file.name,
        url: file.url
      }));
    })
    return attachmentsControl;
  }

  addExpensesItems() {
    this.ExpensesitemArray.push(this.itemsArray([]));
  }

  stringToDate(value) {
    const dateObject = {
      date: {
        year: value.getFullYear(),
        month: (value.getMonth() + 1), day: (value.getDate())
      }
    };
    return dateObject;
  }

  attachGroup(data) {
    return this.formBuilder.group({
      'key': data.key,
      'name': data.name,
      'url': data.url
    })
  }
  removeAttachment(index): void {
    const arrayControl = <FormArray>this.editForm.controls['items'];
    arrayControl.removeAt(index);
  }

  get ExpensesitemArray() {
    return this.editForm.get('items') as FormArray;
  }

  getFileDetails(e, index) {
    const frmData = new FormData();
    this.spinnerService.show();
    for (var i = 0; i < e.target.files.length; i++) {
      frmData.append("file", e.target.files[i]);
    }
    if (e.target.files.length) {
      this.reimbur.getUploadFile(frmData).subscribe(files => {
        this.spinnerService.hide();
        files.forEach(filesData => {
          this.ExpensesitemArray.controls[index]['controls'].attachments.push(this.attachGroup(filesData))
        });
      }, error => {
        this.spinnerService.hide();
      });
    };
  }
  dateToString(value) {
    const dateString = value.date.year + '-' +
      (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
      (value.date.day < 10 ? '0' : '') + value.date.day;
    return dateString;
  }
  onSubmit(formData) {
    this.validateAllFields(this.editForm);
    if (this.submit) {
      if (this.editForm.valid) {
        formData.value.from_date = this.dateToString(this.editForm['controls']['from_date'].value);
        formData.value.to_date = this.dateToString(this.editForm['controls']['to_date'].value);
        formData.value.items.forEach(dateFormat => {
          if (typeof dateFormat.date == "object") {
            dateFormat.date = this.dateToString(dateFormat.date);
          } else {
            dateFormat.date = dateFormat.date;
          }
        });
        this.reimbur.updateUser(formData.value, this.id, this.statusKey).subscribe(userDetail => {
          this.updateData = userDetail;
          this.flashService.show(userDetail['message'], 'alert-success');
          this.router.navigate(['/reimbursement/list']);
        });
      }
    } else {
      if (this.editForm.valid) {
        formData.value.from_date = this.dateToString(this.editForm['controls']['from_date'].value);
        formData.value.to_date = this.dateToString(this.editForm['controls']['to_date'].value);

        formData.value.items.forEach(dateFormat => {
          if (typeof dateFormat.date == "object") {
            dateFormat.date = this.dateToString(dateFormat.date);
          } else {
            dateFormat.date = dateFormat.date;
          }
        });

        this.reimbur.updateSaveUser(formData.value, this.id).subscribe(userDetail => {
          this.updateData = userDetail;
          this.flashService.show(userDetail['message'], 'alert-success');
          this.router.navigate(['/reimbursement/list']);
        });
      }

    }

  }
  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormArray) {
        if (control instanceof FormArray && field === 'attachments') {
          control.markAsDirty();
        }
        for (const control1 of control.controls) {
          if (control1 instanceof FormControl) {
            control1.markAsTouched({
              onlySelf: true
            });
          }
          if (control1 instanceof FormGroup) {
            this.validateAllFields(control1);
          }
        }
      }
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }


  removeFiles(k, attachment, i) {
    this.k = k;
    this.attachments = attachment;
    this.i = i;
  }

  delete() {
    if (this.attachments.value.key) {
      let key = [];
      key.push(this.attachments.value.key);
      this.reimbur.deleteUploadFile(key).subscribe(response => {
        this.ExpensesitemArray.controls[this.i]['controls']['attachments'].controls.splice(this.k, 1);
        this.close.nativeElement.click();
        this.flashService.show(response['message'], 'alert-success')
      });
    }
  }

  trackByFn(index) {
    return index;
  }
  saveForUser() {
    this.submit = false;
  }

  submitForUser() {
    this.submit = true;
  }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-user-edit/reimbursement-user-edit.component.ts